import React, { useContext, useState } from 'react';
import { APIINTEGRACION } from '../../helpers/url';
import useWindowDimensions from "../../helpers/useWindowDimensions";
import { Excedente } from "../../assets/icons/dashboard";
import { Card, Row, Col} from 'react-bootstrap';
import CardResumenPago from '../cards/CardResumenPago';
import ButtonProgreso from '../buttons/Button'
import { useLocation } from 'react-router-dom';
import { TextColored } from "../typography"
import { ThemeContext } from "../../theming";
import Alert from "../../assets/icons/alert.svg";
import Loading from '../loading/Loading';
import { api } from "../../helpers/api";
import Header from '../header/Header';
function VentaFracasada() {
    const { state } = useLocation();
    const { width } = useWindowDimensions();
    const app = useContext(ThemeContext);
    const [showLoading, setShowLoading] = useState({ display: 'none' });

    const { body28 } = app.theme.font;
    const icons = {
        cuotas: <Excedente />
    }
    const container = {
        // borderRightWidth: "50px",
        // borderRightColor: "black",
        // borderRightStyle: "solid",
        width: "100%",
        display: "flex",
        justifyContent: "center",
    };
    const redirectBandeja = async()=>{
        setShowLoading({ display: "block" });
        const { data } = await api.post(APIINTEGRACION.POST.REDIRECT+state.w);
        setShowLoading({ display: "none" });
        window.location.href = data.data;
      }
    return (
        <>
            <section style={{ width: "100%" }}>
            <Header />
            <div style={container}>
            <Loading estilo={showLoading}></Loading>
        <Row
            className="mt-4"
            style={{ width: width >= 701 ? "87%" : "100%" }}
        >
            <Col>
                <Card>
                    <Card.Body>
                        <CardResumenPago
                            icon={icons.cuotas}
                            title='Resumen de Pagos'
                            progress={66}
                            btnBack={false}
                            volverInicio={<ButtonProgreso
                                    className='noprint'
                                    sizeText={1}
                                    onClick={redirectBandeja}
                                    >
                                    Volver al Inicio
                                </ButtonProgreso>}>
                            <div className='d-flex flex-column my-3 w-75 align-items-center'>
                                <div style={{ width: width > 701 ? '75%' : '85%' }}>
                                    <div className='d-flex align-items-center mb-4'>
                                        <img src={Alert} alt="Alert logo" />
                                        <TextColored type="primary" size={body28} style={{ marginLeft: "12px" }} >TRANSACCIÓN FRACASADA</TextColored>
                                    </div>
                                    <div>
                                        <div className="mb-1">
                                            <b >Las posibles causas de este rechazo son:</b>
                                        </div>
                                        <br />
                                        <span>- Error en el ingreso de los datos de tu tarjeta de crédito.</span>
                                        <br />
                                        <span>- Su tarjeta de crédito no cuenta con el cupo necesario para cancelar la compra.</span>
                                        <br />
                                        <span>- Tarjeta aún no habilitada en el sistema financiero.</span>
                                        <br />
                                        <span>- Si el problema persiste favor comunicarse con su banco emisor.</span>
                                    </div>
                                </div>
                            </div>
                        </CardResumenPago>
                    </Card.Body>
                </Card>
            </Col>
        </Row>
        </div>
        </section>
    </>
    )
}

export default VentaFracasada